import React from "react";
import * as Animate from "react-reveal";

const MBAExtrasSection = () => {
  return (
    <section className="py-16 md:py-24 lg:py-28 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-heading gap-10 lg:gap-16 items-end mb-10 lg:mb-12">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                Beyond the modules
              </p>
              <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight m-0">
                A complete learning experience, built around practice and
                community.
              </h2>
            </div>
          </Animate.Fade>
          <Animate.Fade bottom>
            <p className="font-poppins text-gray text-sm leading-loose m-0">
              Complete the required work, extend the experience in person and
              continue learning through the graduate community.
            </p>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-mba-extras gap-3.5">
          <Animate.Fade bottom>
            <article className="bg-primary text-white rounded-3xl min-h-[315px] p-7 flex flex-col h-full">
              <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
                01 · Certificate
              </span>
              <h3 className="font-poppins text-white font-semibold text-2xl leading-snug mt-auto mb-3">
                Earn the Utiva Global MBA Certificate.
              </h3>
              <p className="font-poppins text-blue-100 text-sm leading-relaxed m-0">
                Recognizing completion across leadership, growth, finance,
                execution, risk, AI, innovation and digital transformation—with
                learning access across five international university
                partnerships.
              </p>
            </article>
          </Animate.Fade>

          <Animate.Fade bottom>
            <article className="border border-hire-line rounded-3xl min-h-[315px] p-7 flex flex-col h-full">
              <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
                02 · Optional experience
              </span>
              <h3 className="font-poppins text-primary font-semibold text-lg leading-snug mt-auto mb-3">
                Utiva Business Residency
              </h3>
              <p className="font-poppins text-gray text-sm leading-relaxed m-0">
                An optional, separately priced physical experience with
                leadership workshops, industry conversations and boardroom-style
                presentations.
              </p>
            </article>
          </Animate.Fade>

          <Animate.Fade bottom>
            <article className="border border-hire-line rounded-3xl min-h-[315px] p-7 flex flex-col h-full">
              <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
                03 · Alumni network
              </span>
              <h3 className="font-poppins text-primary font-semibold text-lg leading-snug mt-auto mb-3">
                Utiva Business Network
              </h3>
              <p className="font-poppins text-gray text-sm leading-relaxed m-0">
                A long-term professional community for continued learning,
                networking, collaboration and business opportunities.
              </p>
            </article>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default MBAExtrasSection;
